import { createUseStyles } from 'react-jss'
import { FONT_MEDIUM } from '@styles/fonts'

export default createUseStyles({
  button: {
    fontFamily: FONT_MEDIUM
  }
})
